// extracted by mini-css-extract-plugin
module.exports = {"travel_box":"travel_box-1aVdZF-w"};